import { IEditComboGroupState } from './editComboGroupContext';
import { EditComboGroupActionTypes, TEditComboGroupAction } from './editComboGroupActions';

export const editComboGroupReducer = (
	state: IEditComboGroupState,
	action: TEditComboGroupAction,
): IEditComboGroupState => {
	switch (action.type) {
		case EditComboGroupActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
			};
		case EditComboGroupActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditComboGroupActionTypes.SET_ALL_DATA:
			return {
				...state,
				comboGroupId: action.payload.comboGroupId,
				selectedCustomer: action.payload.customer,
				selectedRestaurants: action.payload.restaurants,
				selectedDishes: action.payload.dishes,
				name: action.payload.name,
				selectedComboItems: action.payload.comboItems,
				upperLimit: action.payload.upperLimit,
				lowerLimit: action.payload.lowerLimit,
				translations: action.payload.translations,
			};
		case EditComboGroupActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditComboGroupActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case EditComboGroupActionTypes.SET_RESTAURANTS:
			return {
				...state,
				selectedRestaurants: action.payload.restaurants,
			};
		case EditComboGroupActionTypes.SET_FETCHED_DISHES:
			return {
				...state,
				fetchedDishes: action.payload.dishes,
			};
		case EditComboGroupActionTypes.SET_DISHES:
			return {
				...state,
				selectedDishes: action.payload.dishes,
			};
		case EditComboGroupActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditComboGroupActionTypes.SET_FETCHED_COMBO_ITEMS:
			return {
				...state,
				fetchedComboItems: action.payload.comboItems,
			};
		case EditComboGroupActionTypes.SET_COMBO_ITEMS:
			return {
				...state,
				selectedComboItems: action.payload.comboItems,
			};
		case EditComboGroupActionTypes.CHANGE_UPPER_LIMIT:
			return {
				...state,
				upperLimit: action.payload.upperLimit,
			};
		case EditComboGroupActionTypes.CHANGE_LOWER_LIMIT:
			return {
				...state,
				lowerLimit: action.payload.lowerLimit,
			};
		case EditComboGroupActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE:
			return {
				...state,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case EditComboGroupActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case EditComboGroupActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case EditComboGroupActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditComboGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditComboGroupActionTypes.RESET_FIELDS:
			return {
				...state,
				fetchedRestaurants: [],
				selectedRestaurants: [],
				fetchedDishes: [],
				selectedDishes: [],
				name: '',
				fetchedComboItems: [],
				selectedComboItems: [],
				upperLimit: '',
				lowerLimit: '',
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
